import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { CardsModule } from '@shared/cards/cards.module';
import { EntityModule } from '@shared/entity/entity.module';
import { AddressModule } from '@shared/address/address.module';
import {
  OnBoardingCardComponent,
  OnBoardingCardsComponent,
  SelfFilerAbiClientRepresentativeFormComponent,
  SelfFilerAbiProfileFormComponent,
  SelfFilerAchDebitFormComponent,
  SelfFilerCodeAddAdditionalPortsComponent,
  SelfFilerCodeFormComponent,
  SelfFilerFieldViewComponent,
  SelfFilerSectionComponent,
  SelfFilerSetFilerCodeFormComponent,
} from './components';
import { MutualModule } from '@shared/mutual/mutual.module';
import { DocumentModule } from '@shared/document/document.module';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';

@NgModule({
  declarations: [
    OnBoardingCardsComponent,
    OnBoardingCardComponent,
    SelfFilerCodeFormComponent,
    SelfFilerSectionComponent,
    SelfFilerSetFilerCodeFormComponent,
    SelfFilerCodeAddAdditionalPortsComponent,
    SelfFilerAbiProfileFormComponent,
    SelfFilerAbiClientRepresentativeFormComponent,
    SelfFilerFieldViewComponent,
    SelfFilerAchDebitFormComponent,
  ],
  imports: [
    CommonModule,
    CustomModalModule,
    RouterModule,
    PipesSharedModule,
    CardsModule,
    FormWrapperModule,
    EntityModule,
    AddressModule,
    MutualModule,
    DocumentModule,
  ],
  exports: [OnBoardingCardsComponent, SelfFilerCodeFormComponent, SelfFilerAbiProfileFormComponent, SelfFilerAchDebitFormComponent],
})
export class SelfFilerModule {}
